import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';
import PositiveToast from './PositiveToast';

const CreatedWithUrlToast = ({
  className,
  name,
  url,
  messageId,
}) => (
  <PositiveToast className={clsx('aridhia-created-with-url-toast', className)}>
    <FormattedMessage id={messageId} />
    <Link to={url}>
      {name}
    </Link>
    <FormattedMessage id="toast.created" />
  </PositiveToast>
);

export default CreatedWithUrlToast;
